enum StackDirection {
  Undecided,
  Up,
  Down,
  Finished,
}
export default StackDirection;
